import * as t from './actionType';

export function setCurrentStep(step) {
  return {
    type: t.ASK_FOR_NEXT_STEP,
    step,
  };
}



// WEBPACK FOOTER //
// ./src/services/NavigationService/actions.js